import { inject } from '@angular/core';
import { Router, CanMatchFn } from '@angular/router';
import { environment } from 'src/environments/environment';

export const schedulingEnabledGuard: CanMatchFn = () => {
  if (environment.schedulingEnabled) return true;
  inject(Router).navigate(['/dashboard']);
  return false;
};
